// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".A6_vyH5_tgdEmE6GNZI1 {\n\tcursor: pointer;\n\tcolor: var(--main-blue);\n\tfont-size: 11px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add-link": "A6_vyH5_tgdEmE6GNZI1"
};
export default ___CSS_LOADER_EXPORT___;
